export const FETCH_USER_LOCALE = 'FETCH_USER_LOCALE';

export const LOGOUT_USER = 'LOGOUT_USER';

// navigationOptions saga
export const FETCH_ADMIN_NAV_OPTIONS = 'FETCH_ADMIN_NAV_OPTIONS';
export const FETCH_HEADER_NAV_OPTIONS = 'FETCH_HEADER_NAV_OPTIONS';
export const FETCH_NAV_OPTIONS = 'FETCH_NAV_OPTIONS';

// navOptions reducer
export const SET_ADMIN_NAV_OPTIONS = 'SET_ADMIN_NAV_OPTIONS';
export const SET_HEADER_NAV_OPTIONS = 'SET_HEADER_NAV_OPTIONS';
export const SET_NAV_OPTIONS = 'SET_NAV_OPTIONS';

// dropdownOptions reducer
export const SET_DROPDOWN_OPTIONS = 'SET_DROPDOWN_OPTIONS';
export const SET_DROPDOWN_OPEN = 'SET_DROPDOWN_OPEN';
export const SET_DROPDOWN_CLOSE = 'SET_DROPDOWN_CLOSE';
export const SET_DROPDOWN_SEARCH = 'SET_DROPDOWN_SEARCH';

// userDropdown saga
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const REFRESH_DATA = 'REFRESH_DATA';
